import { LONG_TOAST_DURATION, ENDLESS_TOAST_DURATION, SHORT_TOAST_DURATION } from 'shared/config';
import { ToastType } from 'shared/model/toast';

export const getToastDuration = (type: ToastType): number => {
  switch (type) {
    case 'long':
      return LONG_TOAST_DURATION;
    case 'critical':
      return ENDLESS_TOAST_DURATION;
    default:
      return SHORT_TOAST_DURATION;
  }
};
